module.exports = __webpack_public_path__ + "8962e00b0b01daf993a70ff670e7a311.png";